import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useRef,
} from "react";
import Toasts from "../components/Toasts";
import Modal from "../components/Modal";

const UIContext = createContext(null);

export function useUI() {
  return useContext(UIContext);
}

let toastSeq = 0;

export function UIProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const [modal, setModal] = useState(null); // { title, content } | null
  const [audit, setAudit] = useState([]); // [{ id, t, action, srv, color }]

  const timers = useRef({});

  const removeToast = useCallback((id) => {
    setToasts((list) => list.filter((t) => t.id !== id));
    clearTimeout(timers.current[id]);
    delete timers.current[id];
  }, []);

  const toast = useCallback(
    (msg, type = "ok", dur = 3500) => {
      const id = ++toastSeq;
      setToasts((list) => [...list, { id, msg, type }]);
      timers.current[id] = setTimeout(() => removeToast(id), dur);
    },
    [removeToast]
  );

  const openModal = useCallback((title, content, size) => {
    setModal({ title, content, size });
  }, []);

  const closeModal = useCallback(() => setModal(null), []);

  const addAudit = useCallback((action, srv, color) => {
    const now = new Date();
    const t = [now.getHours(), now.getMinutes()]
      .map((v) => String(v).padStart(2, "0"))
      .join(":");
    setAudit((list) => {
      const next = [...list, { id: Date.now() + Math.random(), t, action, srv, color }];
      return next.length > 8 ? next.slice(next.length - 8) : next;
    });
  }, []);

  const value = { toast, openModal, closeModal, addAudit, audit };

  return (
    <UIContext.Provider value={value}>
      {children}
      <Toasts toasts={toasts} />
      <Modal modal={modal} onClose={closeModal} />
    </UIContext.Provider>
  );
}
